"use client"

import type React from "react"
import { memo } from "react"

interface MobileMenuButtonProps {
  isOpen: boolean
  onToggle: () => void
}

const MobileMenuButton: React.FC<MobileMenuButtonProps> = memo(({ isOpen, onToggle }) => (
  <button
    className={`mobile-menu-button ${isOpen ? "open" : ""}`}
    onClick={onToggle}
    aria-label="Toggle menu"
    aria-expanded={isOpen}
  >
    <div className="hamburger">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </button>
))

MobileMenuButton.displayName = "MobileMenuButton"

export default MobileMenuButton
